import { render, staticRenderFns } from "./CookieSettings.vue?vue&type=template&id=c25634d2"
import script from "./CookieSettings.vue?vue&type=script&lang=js"
export * from "./CookieSettings.vue?vue&type=script&lang=js"
import style0 from "./CookieSettings.vue?vue&type=style&index=0&id=c25634d2&prod&module=true&lang=scss"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports